import Vue from "vue";
import Router from "vue-router";
// import Login from './Login'
// import Mine from './Mine'
// import Count from './Count'
// import Home from './Home'
import Login from "@/page/login/Login";
import ForgetPS from "@/page/login/forgetPS/ForgetPS";
import SetNewPS from "@/page/login/setNewPS/SetNewPS";
import Source from "@/page/Source";
import Mine from "@/page/mine/Index";
import RecordList from "@/page/mine/withdraw/recordList/recordList";
import Help from "@/page/mine/help/Help";
import Bill from "@/page/mine/bill/Bill";
import BillDetail from "@/page/mine/bill/billDetail/BillDetail";
import Message from "@/page/mine/message/Message";
import AboutUs from "@/page/mine/aboutUs/AboutUs";
import Order from "@/page/mine/order/Index";
import OrderDetails from "@/page/mine/order/Details";
import Withdraw from "@/page/mine/withdraw/Withdraw";
import DrawMode from "@/page/mine/withdraw/drawMode/DrawMode";
import BindZFB from "@/page/mine/withdraw/bindZFB/BindZFB";
import Plan from "@/page/mine/plan/Plan";
import Share from "@/page/mine/share/Index";
import ShareDetails from "@/page/mine/share/details/ShareDetails";
import ShareList from "@/page/mine/share/list/ShareList";
import Setting from "@/page/mine/setting/Setting";
import EditInfo from "@/page/mine/setting/editInfo/EditInfo";
import UpdateMobile from "@/page/mine/setting/updateMobile/UpdateMobile";
import ReportForms from "@/page/reportForms";
import Home from "@/page/home";
Vue.use(Router);

const router = new Router({
    mode: "history",
    // base: "/agent-h5/",
    routes: [
        {
            path: "/login",
            name: "Login",
            component: Login,
            meta: {
                title: "登录"
            }
        },
        {
            path: "/forgetPS",
            name: "ForgetPS",
            component: ForgetPS,
            meta: {
                title: "忘记密码"
            }
        },
        {
            path: "/setNewPS",
            name: "SetNewPS",
            component: SetNewPS,
            meta: {
                title: "设置新密码"
            }
        },
        {
            path: "/source",
            name: "Source",
            component: Source,
            meta: {
                title: ""
            }
        },
        {
            path: "/mine",
            name: "Mine",
            component: Mine,
            meta: {
                title: "我的"
            }
        },
        {
            path: "/help",
            name: "Help",
            component: Help,
            meta: {
                title: "帮助中心"
            }
        },
        {
            path: "/bill",
            name: "Bill",
            component: Bill,
            meta: {
                title: "账单明细"
            }
        },
        {
            path: "/billDetail/:type/:id",
            name: "BillDetail",
            component: BillDetail,
            meta: {
                title: "账单详情"
            }
        },
        {
            path: "/message",
            name: "Message",
            component: Message,
            meta: {
                title: "我的消息"
            }
        },
        {
            path: "/aboutUs",
            name: "AboutUs",
            component: AboutUs,
            meta: {
                title: "关于我们"
            }
        },
        {
            path: "/order",
            name: "Order",
            component: Order,
            meta: {
                title: "订单明细"
            }
        },
        {
            path: "/orderDetails",
            name: "OrderDetails",
            component: OrderDetails,
            meta: {
                title: "订单详情"
            }
        },
        {
            path: "/withdraw",
            name: "Withdraw",
            component: Withdraw,
            meta: {
                title: "提现"
            }
        },
        {
            path: "/recordList",
            name: "RecordList",
            component: RecordList,
            meta: {
                title: "提现记录"
            }
        },
        {
            path: "/drawMode",
            name: "DrawMode",
            component: DrawMode,
            meta: {
                title: "提现方式 "
            }
        },
        {
            path: "/bindZFB",
            name: "BindZFB",
            component: BindZFB,
            meta: {
                title: "设置支付宝"
            }
        },
        {
            path: "/plan",
            name: "Plan",
            component: Plan,
            meta: {
                title: "区域代理"
            }
        },
        {
            path: "/share",
            name: "Share",
            component: Share,
            meta: {
                title: "推广中心"
            }
        },
        {
            path: "/shareDetails/:id",
            name: "ShareDetails",
            component: ShareDetails,
            meta: {
                title: "海报"
            }
        },
        {
            path: "/shareList",
            name: "ShareList",
            component: ShareList,
            meta: {
                title: "文案列表"
            }
        },
        {
            path: "/setting",
            name: "Setting",
            component: Setting,
            meta: {
                title: "设置"
            }
        },
        {
            path: "/editInfo/:type",
            name: "EditInfo",
            component: EditInfo,
            meta: {
                title: "修改"
            }
        },
        {
            path: "/updateMobile",
            name: "UpdateMobile",
            component: UpdateMobile,
            meta: {
                title: "修改手机号码"
            }
        },
        {
            path: "/reportForms",
            name: "ReportForms",
            component: ReportForms,
            meta: {
                title: "报表"
            }
        },
        {
            path: "/home",
            name: "Home",
            component: Home,
            meta: {
                title: "首页"
            }
        },
        // 找不到路径，则统一跳到个人中心
        { path: "*", redirect: "/mine" }
    ]
});

// 切换页面组件的时候，改变title
router.beforeEach((to, form, next) => {
    /*路由变化修改title*/
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js